import ChromaKey from './ChromaKey.vue';
import ChromaKeySliders from './ChromaKeySliders.vue';
export { ChromaKeySliders };
export default ChromaKey;
